import * as React from 'react'
import { SVGProps } from 'react'
const SvgTableRowsSplit: React.FC<React.SVGProps<SVGSVGElement>> = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className="table-rows-split_svg__lucide table-rows-split_svg__lucide-table-rows-split-icon table-rows-split_svg__lucide-table-rows-split"
    {...props}>
    <path d="M14 10h2M15 22v-8M15 2v4M2 10h2M20 10h2M3 19h18M3 22v-6a2 2 135 0 1 2-2h14a2 2 45 0 1 2 2v6M3 2v2a2 2 45 0 0 2 2h14a2 2 135 0 0 2-2V2M8 10h2M9 22v-8M9 2v4" />
  </svg>
)
export default SvgTableRowsSplit
